import { Modal } from "PFComponents/modal";
import { Typography } from "PFComponents/typography";
import { useTranslation } from "react-i18next";

type PendingEditsModalProps = {
  onSaveAndContinue: () => void;
  onCancel: () => void;
};

export const PendingEditsModal = ({ onSaveAndContinue, onCancel }: PendingEditsModalProps) => {
  const { t } = useTranslation("activities", { keyPrefix: "manageRoles" });
  const { t: tTranslation } = useTranslation();

  return (
    <Modal
      title={t("pendingEditsModal.title")}
      labelOK={t("saveAndContinue")}
      labelCancel={tTranslation("cancel")}
      onOK={onSaveAndContinue}
      onCancel={onCancel}
      onClose={onCancel}
    >
      <Typography variant="bodyRegular">{t("pendingEditsModal.message")}</Typography>
    </Modal>
  );
};
